<template>
  <div class="row">
    <div class="col-md-12" v-for="url in urls">
      <div class="box box-primary">
        <div class="overlay" v-if="url.loading">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">{{ url.title }}</h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getAvertissement(url.url)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover table-responsive">
            <thead>
            <tr>
              <th>Numéro de licence</th>
              <th>Nom</th>
              <th>Prenom</th>
              <th>Statut</th>
              <th v-if="url.url=='membresWithLicenceImpayeeOuIncomplete'">Document d'inscription</th>
              <th v-if="url.url=='membresWithLicenceImpayeeOuIncomplete'">Payement</th>
              <th v-if="url.url=='membresPoomToDan'">Grade aujourd'hui</th>
              <th v-if="url.url=='membresPoomToDan'">Age aujourd'hui</th>
              <th>Erreur détectée</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="result in url.result">
              <td>
                <router-link :to="{ name: 'Member', params: { member_id: result.id }}">
                  {{ result.numlicenceABFT }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'Member', params: { member_id: result.id }}">
                  {{ result.nom }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'Member', params: { member_id: result.id }}">
                  {{ result.prenom }}
                </router-link>
              </td>
              <td>
                <span :class="{'text-green':result.isLicencie!=null, 'text-red':result.isLicencie==null}">{{
                    result.isLicencie != null ? "Licencie" : "Non-licencié"
                  }}</span>
              </td>
              <td v-if="url.url=='membresPoomToDan'">{{ result.grade }}</td>
              <td v-if="url.url=='membresPoomToDan'">{{ result.age }} ans</td>
              <td v-if="url.url=='membresWithLicenceImpayeeOuIncomplete'"><span
                :class="{'text-green':result.licences[0].inscription==1, 'text-red':result.licences[0].inscription==0}">{{
                  result.licences[0].inscription == 1 ? "Reçu" : "Non-reçu"
                }}</span>
              </td>
              <td v-if="url.url=='membresWithLicenceImpayeeOuIncomplete'"><span
                :class="{'text-green':result.licences[0].payement==1, 'text-red':result.licences[0].payement==0}">{{
                  result.licences[0].payement == 1 ? "Reçu" : "Non-reçu"
                }}</span></td>
              <td v-if="url.url=='membresWithDateNaissanceIncorrecte'">{{ result.date_naissance }}</td>
              <td v-if="url.url=='membresWithDoubleLicence'">Double licence</td>
              <td v-if="url.url=='membresWithLicenceImpayeeOuIncomplete'">Processus de licence incomplet</td>
              <td v-if="url.url=='membresPoomToDan'">Doit être régularisé en Dan</td>
              <td v-if="url.url=='membresWithLicenceNonRecap'">Une des licences de ce membre n'est pas liée à un récap
              </td>
              <td v-if="url.url=='membresLicenciesButClubNotLicencie'">
                <router-link :to="{ name: 'Club', params: { club_id: result.lastClub.club.id }}">
                  {{ result.lastClub.club }}
                </router-link>
                n'est pas licencié
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

var _ = require('underscore')

var moment = require('moment')

export default {
  data() {
    return {
      urls: {
        membresWithDateNaissanceIncorrecte: {
          loading: false,
          url: "membresWithDateNaissanceIncorrecte",
          title: "Membres avec date de naissance incorrecte",
          result: [],
        },
        membresWithDoubleLicence: {
          loading: false,
          url: "membresWithDoubleLicence",
          title: "Membres avec une double licence",
          result: [],
        },
        membresWithLicenceImpayeeOuIncomplete: {
          loading: false,
          url: "membresWithLicenceImpayeeOuIncomplete",
          title: "Membres dont la licence est impayée ou incomplète",
          result: [],
        },
        membresWithLicenceNonRecap: {
          loading: false,
          url: "membresWithLicenceNonRecap",
          title: "Membres dont une licence n'est pas liée à un récap ",
          result: [],
        },
        membresLicenciesButClubNotLicencie: {
          loading: false,
          url: "membresLicenciesButClubNotLicencie",
          title: "Membres licenciés dans des clubs non-licenciés",
          result: [],
        },
        membresPoomToDan: {
          loading: false,
          url: "membresPoomToDan",
          title: "Membres gradés Poom qui devraient être gradés Dan",
          result: [],
        },

      },

    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    }),

  },
  mounted: function () {
    _.each(this.urls, item => {
      this.getAvertissement(item.url);
    })
    // this.urls.forEach(item => {
    //     this.getAvertissement(item.url);
    // })
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
    }),

    getAvertissement: function (url) {
      let self = this;
      this.urls[url].loading = true
      self.$http.get(this.getRoute('Avertissement.' + url)).then((response) => {
        this.urls[url].result = response.body
        if (url == "membresPoomToDan") {
          this.urls["membresPoomToDan"].result = _.sortBy(response.body, 'isLicencie').reverse();
        }
        this.urls[url].loading = false
      }, (response) => {
      });
    },

  },
  beforeRouteUpdate(to, from, next) {
  },

  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Avertissement/Avertissement_membre.vue